import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const RevenueBarChart = ({ mode, Sro, fromDate, todate }) => {
  ;
  const [chartData, setChartData] = useState([]);
  const [lable, setlable] = useState([]);
  const [datasets, setdatasets] = useState([]);
  const [dashboardDistrictData, setDashboardDistrictData] = useState([]);

  const [formData, setFormData] = useState({
    mode: mode,
    sro: Sro,
    fromdate: fromDate,
    todate: todate,
  });
  console.log("mode", lable);
  console.log("mode", datasets);


  const data = {
    labels: lable,
    datasets: datasets,
  };

  console.log(data);
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          autoSkip: false,
          maxRotation: mode === "district" ? 0 : 90, // Horizontal for district, vertical for sro wise
          minRotation: mode === "district" ? 0 : 90,
          align: "center",
        },
        grid: {
          display: false, // Hide grid lines on X-axis
        },
        barPercentage: 0.8, // Adjust space between bars
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return value.toLocaleString();
          },
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${
              tooltipItem.dataset.label
            }: ${tooltipItem.raw.toLocaleString()}`;
          },
        },
      },
      datalabels: {
        display: false, // Hide labels on bars
      },
    },
  };



  useEffect(() => {
    console.log("mode:", mode);
    const mode_2 = mode.mode;
    console.log("formData:", formData);
    ;
    fetchData();
  }, [mode, fromDate, todate]);
  // Dependency array
  const fetchData = async () => {
    try {
      console.log("formData:", formData);
      const response = await axios.get(
        `${API_BASE_URL}/DashBoard/GetBarChartData?mode=${mode}&sro=${Sro}&fromdate=${fromDate}&todate=${todate}`
        // {
        //   params: formData, // Send formData as query parameters
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // }
      );

      console.log("Response:", response.data);
      // setlable(response.data.labels);
      // setdatasets(response.data.datasets);
      console.log("labels:", response.data.labels);
      console.log("datasets:", response.data.datasets);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchDashboardDistrictData = async () => {
    debugger
    try {
      const response = await axios.get(
        `${API_BASE_URL}/DashBoard/Virtual_Dashboard_total_doc_Revenue_district_wise`
      );

      console.log("Response:", response.data);
      setlable(response.data.labels);
      setdatasets(response.data.datasets);
      console.log("labels:", response.data.labels);
      console.log("datasets:", response.data.datasets);
    } catch (error) {
      console.error("Error fetching SRO data:", error);
    }
};
  
    
useEffect(() => {
  fetchDashboardDistrictData();
 
}, []);
  return (
   
    <div
      style={{ height: "50vh" }}
      className="w-full h-full overflow-x-auto sm:overflow-x-hidden overflow-y-hidden"
    >
      {chartData ? <Bar data={data} options={options} /> : <p>Loading...</p>}
    </div>
  );
};

export default RevenueBarChart;
